import "./Dashboard.css";
import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import FeatherIcon from "feather-icons-react";
import ProfileDropdown from "../UserDashboardLayout/ProfileDropdown";
import SideBarContent from "./AdminLeftSidebar";
import logo from "../../assets/Logo/Cgear_Black.webp";

// Admins and resellers get "My Profile" here and nowhere else: it is their own
// account, not a management screen, so it does not belong in the sidebar next to
// Users and Licenses. The page itself is the same one customers see.
const ProfileMenus = [
  {
    label: "My Profile",
    icon: "user",
    redirectTo: "/Profile",
  },
  {
    label: "Logout",
    icon: "log-out",
    redirectTo: "/",
  },
];

const AdminDashboardLayout = (props) => {
  const isMobile = window.innerWidth < 768; // adjust breakpoint if needed
  const [sidebar, setSidebar] = useState(!isMobile);
  const showSidebar = () => {
    setSidebar(!sidebar);
    // Toggle class on content-page when sidebar state changes
    const contentPage = document.querySelector(".content-page");
    if (contentPage) {
      contentPage.classList.toggle("collapsed-sidebar", sidebar);
    }
  };
  return (
    <React.Fragment>
      <div>
        <div className="navbar-custom">
          <div className="container-fluid p-0 d-flex align-items-center justify-content-between">
            <div className="topnav-left d-flex align-items-center">
              <button
                className="button-menu-mobile"
                onClick={showSidebar}
                aria-label="Toggle sidebar"
              >
                <FeatherIcon icon="menu" />
              </button>
            </div>
            <div className="topnav-right d-flex align-items-center">
              <ProfileDropdown
                profilePic={logo}
                menuItems={ProfileMenus}
                username={localStorage.getItem('email') || 'Admin'}
              />
            </div>
          </div>
        </div>
        <div
          className={`left-side-menu  ${
            sidebar ? "activeDash" : "hideSideBar"
          }`}
        >
          <SideBarContent />
        </div>
      </div>
    </React.Fragment>
  );
};
export default AdminDashboardLayout;
